<div class="modal-header">
    <h4 class="modal-title pull-left">Add {{userRoleToSort}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <div class="table-responsive">
            <div>
                <input class="form-control be-input margin-bottom-20" [(ngModel)]="searchValue" (keyup)="onSearch(searchValue)" maxlength="200" placeholder="Search {{userRoleToSort}}">
            </div>
            <table class="table basictable row-border hover" id="dtTable" datatable [dtOptions]="dtOptions">
                <tbody>
                    <tr *ngFor="let user of users;let i = index ">
                        <td>
                            <ul class="connection-list brokerlist be-exchange-list">
                                <li class="clearfix">

                                    <div class="right">
                                        <h6>
                                            {{user.Name}}
                                        </h6>
                                        <p>
                                            <i class="icon-phone icon"></i> {{user.Phone|phone}}
                                        </p>
                                        <p>
                                            <i class="icon-message icon"></i> {{user.Email}}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <p><a href="javascript:void(0);" class="be-small-atag pull-right" (click)="onUserSelect(user)">Add</a></p>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr *ngIf="users?.length == 0 ">
                        <td colspan="1" class="odd no-data-available">
                            <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>